__turbopack_context__.v({
  "artCircle": "_6iUAnq_artCircle",
});
